import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { Text, Breadcrumb, constants } from '@adc/ui-adc'
import { getAddressFilters } from '../../converters/seoBuilder'
import { getStateName } from '../../converters/location'
import cls from './index.scss'

const cx = classnames.bind(cls)

const stateList = constants.optionLists.states
const states = {}
stateList.forEach(state => {
  states[state.value] = state.text
})

const optionalSuffix = (string, suffixTest, suffixAppend) =>
  string.toLowerCase().endsWith(suffixTest) ? string : string + suffixAppend

const hasBreadCrumbFilters = filters =>
  _.get(filters, 'city[0]') ||
  _.get(filters, 'county[0]') ||
  _.get(filters, 'state[0]')
export const buildBreadCrumbs = filters => {
  const address = getAddressFilters(filters)
  const hasCity = _.get(address, 'city')
  const hasCounty = _.get(address, 'county')
  const hasState = _.get(address, 'state')

  const out = [
    ...(hasState
      ? [
          {
            label: getStateName(address.state),
            url: `/residential/${address.state.toLowerCase()}`,
          },
        ]
      : []),
    ...(hasState && hasCity
      ? [
          {
            label: address.city,
            url: `/residential/${address.state.toLowerCase()}/${_.kebabCase(
              address.city
            )}_ct`,
          },
        ]
      : []),
    ...(hasState && hasCounty
      ? [
          {
            label: optionalSuffix(address.county, 'county', ' County'),
            url: optionalSuffix(
              `/residential/${address.state.toLowerCase()}/${_.kebabCase(
                address.county
              )}`,
              'county',
              '-county'
            ),
          },
        ]
      : []),
  ]

  return out
}

const breadCrumbLink = ({ label, url } = {}) => ({
  key: label,
  content: <a href={url}>{label}</a>,
})

const activeBreadCrumb = ({ label } = {}) => ({
  key: label,
  content: (
    <Text color='gray' size='tiny'>
      {label}
    </Text>
  ),
  active: true,
})

const BreadCrumbs = ({ filters }) => {
  if (!hasBreadCrumbFilters(filters)) {
    return null
  }
  const breadCrumbList = buildBreadCrumbs(filters)
  const semanticBreadCrumbs = breadCrumbList.map((link, i) =>
    i === breadCrumbList.length - 1
      ? activeBreadCrumb(link)
      : breadCrumbLink(link)
  )

  return (
    <>
      <div
        className={cx('breadcrumbs', 'u-pl-3', 'u-pr-3', 'u-mt-3', 'u-mb-4')}
      >
        <b>
          For Sale Properties in{' '}
          <Breadcrumb icon='right angle' sections={semanticBreadCrumbs} />
        </b>
      </div>
    </>
  )
}

BreadCrumbs.propTypes = {
  filters: PropTypes.object.isRequired,
}

export default BreadCrumbs
